module.exports = __webpack_public_path__ + "41a4957cc87c4208297dc99d8bff60fc.svg";